import './EventsPast.scss';

import sortIcon from '../../assets/images/icons/sort.svg';
import search from '../../assets/images/icons/Search.svg';
import edit from '../../assets/images/icons/edit-purple.svg';

import ReactPaginate from 'react-paginate';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

function EventsPast({ events }) {
    const navigate = useNavigate();

    const sorts = ['name', 'category', 'location', 'dates'];
    const headings = ['Name', 'Category', 'Location', 'Date', 'Event hours', 'Dress-code', 'Music', 'About', 'Likes', 'Check Ins'];

    const [displayPast, setDisplayPast] = useState(events);

    //SORTS =======================================================================================================

    const [nameSortClicks, setNameSortClicks] = useState(1);
    const [catSortClicks, setCatSortClicks] = useState(1);
    const [locationSortClicks, setLocationSortClicks] = useState(1);
    const [dateSortClicks, setDateSortClicks] = useState(1);

    function handleSortClick(by) {

        switch (by) {
            case 'name':
                setNameSortClicks(prevCount => prevCount + 1);
                applyNameFilter();
                break;
            case 'category':
                setCatSortClicks(prevCount => prevCount + 1);
                applyCatFilter();
                break;
            case 'location':
                setLocationSortClicks(prevCount => prevCount + 1);
                applyLocationFilter();
                break;
            case 'dates':
                setDateSortClicks(prevCount => prevCount + 1);
                applyDateFilter();
                break;
            default:
                break;
        }

    }

    function applyNameFilter() {

        let filteredUpcomingEvents;

        switch (nameSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayPast].sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
                filteredUpcomingEvents = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayPast].sort((a, b) => {
                    return b.name.localeCompare(a.name);
                });
                filteredUpcomingEvents = sortedByNameZA;
                break;
            case 3:
                filteredUpcomingEvents = events;
                setNameSortClicks(1);
                break;
            default:
                filteredUpcomingEvents = events;
                break;
        }

        setDisplayPast(filteredUpcomingEvents);
    }

    function applyCatFilter() {

        let filteredUpcomingEvents;

        switch (catSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayPast].sort((a, b) => {
                    return a.tags[0].localeCompare(b.tags[0]);
                });
                filteredUpcomingEvents = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayPast].sort((a, b) => {
                    return b.tags[0].localeCompare(a.tags[0]);
                });
                filteredUpcomingEvents = sortedByNameZA;
                break;
            case 3:
                filteredUpcomingEvents = events;
                setCatSortClicks(1);
                break;
            default:
                filteredUpcomingEvents = events;
                break;
        }

        setDisplayPast(filteredUpcomingEvents);
    }

    function applyLocationFilter() {

        let filteredUpcomingEvents;

        switch (locationSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayPast].sort((a, b) => {
                    return a.location.localeCompare(b.location);
                });
                filteredUpcomingEvents = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayPast].sort((a, b) => {
                    return b.location.localeCompare(a.location);
                });
                filteredUpcomingEvents = sortedByNameZA;
                break;
            case 3:
                filteredUpcomingEvents = events;
                setLocationSortClicks(1);
                break;
            default:
                filteredUpcomingEvents = events;
                break;
        }

        setDisplayPast(filteredUpcomingEvents);
    }

    function applyDateFilter() {

        let filteredUpcomingEvents;

        switch (dateSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayPast].sort((a, b) => {
                    let newA = a.date.split(' - ');
                    let newB = b.date.split(' - ');
                    return new Date(newA[0]) - new Date(newB[0]);
                });
                filteredUpcomingEvents = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayPast].sort((a, b) => {
                    let newA = a.date.split(' - ');
                    let newB = b.date.split(' - ');
                    return new Date(newB[0]) - new Date(newA[0]);
                });
                filteredUpcomingEvents = sortedByNameZA;
                break;
            case 3:
                filteredUpcomingEvents = events;
                setDateSortClicks(1);
                break;
            default:
                filteredUpcomingEvents = events;
                break;
        }

        setDisplayPast(filteredUpcomingEvents);
    }

    //SEARCH BAR ============================================================================

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const handleChange = (event) => {
        setActiveSearch(true);
        setSearchQuery(event.target.value);

        const filtered = events.filter(item =>
            item.name.toLowerCase().includes((event.target.value).toLowerCase())
            // item.email.toLowerCase().includes((event.target.value).toLowerCase()) ||
            // item.phone.includes((event.target.value))
        );
        setFilteredData(filtered);
    };

    const [displayEvents, setDisplayEvents] = useState([]);
    const [activeSearch, setActiveSearch] = useState(false);

    useEffect(() => {
        activeSearch ? setDisplayEvents(filteredData) : setDisplayEvents(events);
    }, [activeSearch, filteredData, events]);

    function handleExitSearch() {
        setActiveSearch(false);
        setSearchQuery('');
    }

    //PAGINATION =================================================================================================

    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(8);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = displayEvents.slice(indexOfFirstPost, indexOfLastPost);

    const paginate = ({ selected }) => {
        setCurrentPage(selected + 1);
    }


    return (
        <section className='past'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className='past__sorts'>
                    {
                        sorts.map((sort, index) => (
                            <button key={index} onClick={() => handleSortClick(sort)} className='past__sorts-button'>
                                <p className='past__sorts-button-text'>
                                    Sort by {sort}
                                </p>
                                <img className='past__sorts-button-icon' src={sortIcon} alt='sort icon'></img>
                            </button>
                        ))
                    }
                </div>
                <div className='events__top-buttons-search'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label htmlFor='search'>
                            <img src={search} className='events__top-buttons-search-icon' alt='magnifying glass'></img>
                        </label>
                        <input
                            id='search'
                            type="text"
                            className='events__top-buttons-search-input'
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleChange}
                        />

                    </div>
                    {activeSearch &&
                        <div onClick={handleExitSearch} className='events__top-buttons-search-x'>
                            <p className='events__top-buttons-search-x-text'>
                                X
                            </p>
                        </div>
                    }
                </div>

            </div>

            <table className='past__table'>
                <thead className='past__table-top'>
                    <tr className='past__table-top-headings'>
                        {
                            headings.map((heading, index) => (
                                <th key={index} className='past__table-top-headings-heading' scope='col'>
                                    {heading}
                                </th>
                            ))
                        }
                    </tr>
                </thead>

                <tbody className='past__table-info'>
                    {
                        currentPosts?.map(event => (
                            <tr key={event.id} className='past__table-info-info'>
                                <td className='past__table-info-info-text'>
                                    {event.name}
                                    <img onClick={() => navigate(`edit/${event.id}`)} src={edit} className='past__table-info-info-text-icon' alt='purple pen'></img>
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.tags[0] ? event.tags[0] : '-'}
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.location ? event.location : '-'}
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.date ? event.date : '-'}
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.hours ? event.hours : '-'}
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.dressCode ? event.dressCode : '-'}
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.music ? event.music : '-'}
                                </td>
                                <td className='past__table-info-info-text past__table-info-info-text--special'>
                                    <div className='truncated'>
                                        <p className='truncated-text'>
                                            {event.description ? event.description : '-'}
                                        </p>
                                    </div>
                                    <p>...</p>

                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.save ? event.save : 0}
                                </td>
                                <td className='past__table-info-info-text'>
                                    {event.checkIns ? event.checkIns : 0}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>

            <div className='pagination-container'>
                <ReactPaginate
                    onPageChange={paginate}
                    pageCount={Math.ceil(displayPast.length / postsPerPage)}
                    previousLabel={'<'}
                    nextLabel={'>'}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    containerClassName={'pagination'}
                    pageLinkClassName={'page-number'}
                    previousLinkClassName={'page-number-prev'}
                    nextLinkClassName={'page-number-next'}
                    activeLinkClassName={'active-number'}
                />

            </div>
        </section>
    )
}

export default EventsPast
